import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../../BaseUrl";
import Swal from "sweetalert2";
// Function to retrieve token from localStorage
const getToken = () => localStorage.getItem("workManagement");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getAllworkdata = createAsyncThunk(
    "work/getAllworkdata",
    async () => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.get(`/work-order/`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const createWorkdata = createAsyncThunk(
    "work/createworkdata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.post(`/work-order/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const getSingleworkdata = createAsyncThunk(
    "work/getSingleworkdata",
    async (id) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.get(`/work-order/${id}`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const updateworkdata = createAsyncThunk(
    "work/updateworkdata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.patch(`/work-order/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const createExceldata = createAsyncThunk(
    "work/createExceldata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.post(`/work-order/many-user`,{data},getAuthHeaders()
        );
        // console.log("response", response);
        // if (response.data.error === false) {
        //   const { totalRecords, successFullUploads, failUploads } = response.data.data;
        //   Swal.fire({
        //     title: 'Excel file uploaded successfully!',
        //     html: `
        //       <b>Total Records:</b> ${totalRecords}<br/>
        //       <b>Successful Uploads:</b> ${successFullUploads}<br/>
        //       <b>Failed Uploads:</b> ${failUploads}`,
        //     icon: 'success',
        //     confirmButtonText: 'OK'
        //   });
        // }
        return response.data;
      // });
      } 
  
      catch (error) {
        Swal.fire({
          title: 'Error!',
          text: 'File not uploaded.',
          icon: 'error',
          confirmButtonText: 'OK'
      });
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
    //delete 
export const deleteWorkData = createAsyncThunk(
  "work/deleteWorkData",
  async (id) => {
    // console.log("cid===>",cid)
    try {
      const response = await baseURL.delete(`/work-order/${id}`,getAuthHeaders());
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      Swal.fire({
        icon: "error",
        title: `${error.response.data.message}`,
      });
      // throw error; // Ensure the error is propagated
    }
  }
);
    //get work order by company ID 
    export const getWorkOrderByCompanyID = createAsyncThunk(
      "work/getWorkOrderByCompanyID",
      async (id) => {
        try {
          const response = await baseURL.get(`/work-order/work-order-number-list`,getAuthHeaders());
          // console.log("response.data", response.data)
          return response.data.data;
        } catch (error) {
          // alert(`${error.response.data.message}`)
          throw error; // Ensure the error is propagated
        }
      }
    );
    //get work order list by work order number  
    export const getWorkOrderByWorkNumber = createAsyncThunk(
      "work/getWorkOrderByWorkNumber",
      async (work_order_numb) => {
        try {
          const response = await baseURL.get(`/work-order/based-work-order-number/${work_order_numb}`,getAuthHeaders());
          // console.log("response.data", response.data)
          return response.data.data;
        } catch (error) {
          // alert(`${error.response.data.message}`)
          throw error; // Ensure the error is propagated
        }
      }
    );
  export const workSlice = createSlice({
    name: "work",
    initialState: {
      workData: [],
      singleWorkData:{},
      workDataByDepartment:[],
      workDataByCompany:[],
      workDataByWorkNumber:[],
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getAllworkdata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getAllworkdata.fulfilled, (state, action) => {
          state.loading = false;
          state.workData = action.payload;
        })
        .addCase(getAllworkdata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        builder
        .addCase(getSingleworkdata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getSingleworkdata.fulfilled, (state, action) => {
          state.loading = false;
          state.singleWorkData = action.payload;
        })
        .addCase(getSingleworkdata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        builder
        .addCase(getWorkOrderByCompanyID.pending, (state) => {
          state.loading = true;
        })
        .addCase(getWorkOrderByCompanyID.fulfilled, (state, action) => {
          state.loading = false;
          state.workDataByCompany = action.payload;
        })
        .addCase(getWorkOrderByCompanyID.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        builder
        .addCase(getWorkOrderByWorkNumber.pending, (state) => {
          state.loading = true;
        })
        .addCase(getWorkOrderByWorkNumber.fulfilled, (state, action) => {
          state.loading = false;
          state.workDataByWorkNumber = action.payload;
        })
        .addCase(getWorkOrderByWorkNumber.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
    },
  });
  
  // SELECTORS
  export const getWorkData = (state) => state.work.workData;
  export const getUniqueWorkData = (state) => state.work.singleWorkData;
  export const getWorkListByCompanyID = (state) =>state.work.workDataByCompany;
  export const getAllWorkOrderByWorkNumb = (state)=>state.work.workDataByWorkNumber
  export const workerror = (state) => state.work.loading;
  
  // EXPORTS
  export default workSlice.reducer;
  